var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentToRender,{tag:"component",attrs:{"field-name":_vm.fieldName,"props-value":_vm.field.value,"uploaded-images":_vm.field.value,"upload-handler":_vm.uploadImagesForPages},on:{"update-content":_vm.updateFieldInfo},model:{value:(_vm.field.value),callback:function ($$v) {_vm.$set(_vm.field, "value", $$v)},expression:"field.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }